import { routeAddFailNotification, routeAddSuccessNotification } from '../../../../notifications/routes/oldRouteNotifications';
import { ProjectRouteAddedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';

export default ({ store, ...payload }: ProjectRouteAddedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;

  if (projectId != null) {
    rootStore.model.fetchRouteByUuid(payload.routeId)?.promise
      .then(() => {
        getAppEnv(store).notification(routeAddSuccessNotification(payload.routeId, payload.name));
        rootStore.model.refreshCalendarRoutes();
      })
      .catch(() => {
        getAppEnv(store).notification(routeAddFailNotification(payload.routeId, payload.name));
      });
  }
};
